<template>
  <l-layout :layout="['xs12']">
    <l-data-table
      :headers="header"
      :get-data-func="getAllPassGroupList"
      title-text="全部通行分组列表"
      search-text="请输入分组名称"
      :filter-items="filter"
      @click:row="goDetails($event.item)"
      clickable></l-data-table>
  </l-layout>
</template>
<script>
  import {time} from '../../../ladmin/utils/time'
  export default{
    name: 'allPassGroup',
    data () {
      return {
        header: [
          {text: '分组名称', value: 'name', align: 'left', sortable: false},
          {text: '到期时间', value: 'expirationTime', align: 'left', sortable: true,f: (v) => (time.stringify(v))},
          {text: '最近修改时间', value: 'lastUpdateTime', align: 'left', placeholder: 'N/A', f: (v) => (time.stringify(v))},
          {text: '是否有效', value: 'rhdata', align: 'left', placeholder: 'N/A', f: (v) => ((JSON.parse(v)).r_h_status === '-1' ? '失效' : '有效'), sortable: false},
        ],
        filter: [
          {
            prependIcon: '$vuetify.icons.edit',
            key: 'rhdata',
            value: '{"r_h_status":"1"}',
            label: '是否有效',
            type: 'select',
            layout: ['xs12', 'sm4'],
            items: [
              {
                value: '',
                text: '全部'
              },
              {
                value: '{"r_h_status":"1"}',
                text: '有效'
              },
              {
                value: '{"r_h_status":"-1"}',
                text: '失效'
              }],
          },
          {
            label: '过期时间',
            layout: 'xs12, sm4',
            type: 'duration',
            key: 'expirationTime',
            value: {},
            range: true,
            f: v => {
              if (!v.startDatetime && !v.endDatetime) {
                return null
              }
              else {
                let s = v.startDatetime + ':00' || 0
                let e = v.endDatetime + ':00' || 9999999999999
                return [s, e]
              }
            }
          },
        ]
      }
    },
    methods: {
      async getAllPassGroupList ({pagination, sortStack, filterItems = [], search}) {
        let {items, amount} = await this.$store.dispatch('passControl/getAllPassGroupList', {pagination, sortStack, filter: filterItems, search: {key: 'name', value: search}})
        let arr = []
        for(let i=0;i<items.length;i++){
          let item = items[i].obgrp
          let obj = {
            name:item.name,
            expirationTime:item.expirationTime,
            lastUpdateTime:item.lastUpdateTime,
            rhdata:item.rhdata,
            id:item.id
          }
          arr.push(obj)
        }
        return {items:arr, amount}
      },
      goDetails (item) {
        console.log(item)
        let selectionString = document.getSelection().toString()
        if (!selectionString) {
          this.$router.push({
            name: 'passGroupDetails',
            params: {id: item.id},
            query: {id: item.id}
          })
        }
      },
    }
  }
</script>
